import Device from '@/helpers/Device';
import StorageHandler, {
  STORE_KEY,
  STORE_VALUE,
} from '@/helpers/StorageHandler';
import store from '@/store';

export default class KeyHandlingLG {
  static get getKeys() {
    return [
      'Menu',             //18
      'ChannelUp',        //427
      'ChannelDown',      //428
      'Alarm',            //701
      'ContextMenu',      //93 APP
      'Guide',            //458
      'GoBack',           //461
      'Portal',           //
      'Exit',             //10182
      'ChannelList',      //10073
      'Guide',            //458
      'MediaPlay',        //415
      'MediaPlayPause',   //10252
      'MediaPause',       //19
      'MediaStop',        //413
      'MediaFastForward', //417
      'MediaRewind',      //412
      'Info',             //457
      '0',                //48
      '1',                //49
      '2',                //50
      '3',                //51
      '4',                //52
      '5',                //53
      '6',                //54
      '7',                //55
      '8',                //56
      '9',                //57
      'Minus',            //189
      'ColorF0Red',       //403
      'ColorF1Green',     //404
      'ColorF2Yellow',    //405
      'ColorF3Blue',      //406
      'Tools',            //10135
      'Source',           //10072
      'Search',           //10225
      'Back',             //461
      'Enter',            //13
    ];
  }

  static get getSpecialKeys() {
    return ['MENU', 'LIST', 'SmartHub', 'Power', 'Sleep'];
  }

  // Wie auf Tizen: die Registrierung gilt fuer die Anwendung, nicht fuer eine
  // Komponente. Einmal pro App-Start genuegt.
  static _keysRegistered = false;

  static registerKeys() {
    if (KeyHandlingLG._keysRegistered) return;
    KeyHandlingLG._keysRegistered = true;
    if (typeof hcap === 'undefined') {
      console.log('[KeyHandlingLG] hcap not ready, registerKeys skipped');
      return;
    }
    /*
    for(let i = 0; i < this.getSpecialKeys.length; i++) {
      try {
        //webapis.appcommon.registerKey([this.getSpecialKeys[i]]);
        hcap.key.addKeyItem({
          "keycode" : 0x00000000,
          "virtualKeycode" : hcap.key.Code.this.getSpecialKeys[i],
          "attribute" : 2,
          "onSuccess" : function() {
              console.log("addKeyItemonSuccess");
          }, 
          "onFailure" : function(f) {
              console.log("addKeyItemonFailure : errorMessage = " + f.errorMessage);
          }
        });
        store.dispatch('notification/new', {
          title: 'Assign Key',
          message: this.getSpecialKeys[i],
        });
      } catch (error) {
        console.log(
          'failed to register ' + this.getSpecialKeys[i] + ': ' + error
        );
      }
    }
    */
    console.log("==============registerKeys", hcap.key.Code);
    /*
    hcap.key.addKeyItem({
      "keycode" : 0x00000461,
      "virtualKeycode" : hcap.key.Code.BACK,
      "attribute" : 2,
      "onSuccess" : function() {
          console.log("addKeyItemonSuccess");
      }, 
      "onFailure" : function(f) {
          console.log("addKeyItemonFailure : errorMessage = " + f.errorMessage);
      }
    });
    */
    hcap.key.addKeyItem({
      "keycode" : 0x00000000,
      "virtualKeycode" : hcap.key.Code.MENU,
      "attribute" : 2,
      "onSuccess" : function() {
          console.log("addKeyItemonSuccess");
      }, 
      "onFailure" : function(f) {
          console.log("addKeyItemonFailure : errorMessage = " + f.errorMessage);
      }
    });
    hcap.key.addKeyItem({
      "keycode" : 0x00000000,
      "virtualKeycode" : hcap.key.Code.LIST,
      "attribute" : 2,
      "onSuccess" : function() {
          console.log("addKeyItemonSuccess");
      }, 
      "onFailure" : function(f) {
          console.log("addKeyItemonFailure : errorMessage = " + f.errorMessage);
      }
    });
    /*hcap.key.addKeyItem({
      "keycode" : 0x00000000,
      "virtualKeycode" : hcap.key.Code.ALARM,
      "attribute" : 2,
      "onSuccess" : function() {
          console.log("addKeyItemonSuccess");
      }, 
      "onFailure" : function(f) {
          console.log("addKeyItemonFailure : errorMessage = " + f.errorMessage);
      }
    });*/
    hcap.key.addKeyItem({
      "keycode" : 0x00000000,
      "virtualKeycode" : hcap.key.Code.APPS,
      "attribute" : 2,
      "onSuccess" : function() {
          console.log("addKeyItemonSuccess");
      }, 
      "onFailure" : function(f) {
          console.log("addKeyItemonFailure : errorMessage = " + f.errorMessage);
      }
    });
    hcap.key.addKeyItem({
      "keycode" : 0x00000000,
      "virtualKeycode" : hcap.key.Code.SMART_HOME,
      "attribute" : 2,
      "onSuccess" : function() {
          console.log("addKeyItemonSuccess");
      }, 
      "onFailure" : function(f) {
          console.log("addKeyItemonFailure : errorMessage = " + f.errorMessage);
      }
    });
    hcap.key.addKeyItem({
      "keycode" : 0x00000000,
      "virtualKeycode" : hcap.key.Code.TV_RAD,
      "attribute" : 2,
      "onSuccess" : function() {
          console.log("addKeyItemonSuccess");
      },
      "onFailure" : function(f) {
          console.log("addKeyItemonFailure : errorMessage = " + f.errorMessage);
      }
    });
    KeyHandlingLG.registerMediaKeys();
    // try {
    //   const value = webapis.appcommon.registerKey([this.getSpecialKeys]);
    //   console.console.log(' result = ' + value);
    // } catch (error) {
    //   console.log(' error code = ' + error.code);
    // }
    // var keyCodes = {};
    // var supportedKeys = tizen.inputdevice.getSupportedKeys();

    // console.log('Supported keys list');
    // for (var i = 0; i < supportedKeys.length; ++i) {
    //   keyCodes[supportedKeys[i].name] = supportedKeys[i].code;
    //   console.log(
    //     i + ' : ' + supportedKeys[i].name + ' - ' + supportedKeys[i].code
    //   );
    // }
    for (let i = 0; i < this.getKeys.length; i++) {
      try {
        //LG
        //tizen.tvinputdevice.registerKey(this.getKeys[i]);
        /*
        hcap.key.addKeyItem({
          "keycode" : 0x00000000,
          "virtualKeycode" : hcap.key.Code[this.getKeys[i]],
          "attribute" : 2,
          "onSuccess" : function() {
              console.log("------------------------------addKeyItemonSuccess");
          }, 
          "onFailure" : function(f) {
              console.log("-------------------------------addKeyItemonFailure : errorMessage = " + f.errorMessage);
          }
        });
        */
      } catch (error) {
        console.log('failed to register ' + this.getKeys[i] + ': ' + error);
      }
    }
    const keys = ['VolumeDown', 'VolumeUp', 'VolumeMute'];
    for (let i = 0; i < keys.length; i++) {
      try {
        //LG
        //tizen.tvinputdevice.unregisterKey(keys[i]);
      } catch (error) {
        console.log('failed to UNRegister ' + this.getKeys[i] + ': ' + error);
      }
    }
  }
  /**
   * Wiedergabetasten (Play, Pause, Stop, Vor- und Rueckspulen) fuer den
   * VoD-Player anmelden.
   *
   * Auf den meisten webOS-Staenden erreichen diese Tasten die Anwendung schon
   * ohne Anmeldung - auf einigen Hospitality-Firmwares faengt sie aber der
   * eingebaute Media-Player ab, und dann kommt in der App nichts an.
   *
   * Die Namen in hcap.key.Code sind ueber webOS 5 bis 23 NICHT einheitlich
   * (MEDIA_PLAY vs. PLAY, FAST_FORWARD vs. FF). Deshalb wird je Taste eine
   * Liste plausibler Namen durchprobiert und nur angemeldet, was das Geraet
   * wirklich kennt - ein unbekannter Name ergaebe virtualKeycode undefined,
   * und HCAP quittiert das je nach Stand mit einer Ausnahme.
   */
  static registerMediaKeys() {
    if (typeof hcap === 'undefined' || !hcap.key || !hcap.key.Code) return;
    const groups = [
      ['MEDIA_PLAY', 'PLAY'],
      ['MEDIA_PAUSE', 'PAUSE'],
      ['MEDIA_PLAY_PAUSE', 'PLAY_PAUSE'],
      ['MEDIA_STOP', 'STOP'],
      ['MEDIA_FAST_FORWARD', 'FAST_FORWARD', 'FF'],
      ['MEDIA_REWIND', 'REWIND', 'REW'],
    ];
    groups.forEach((names) => {
      const name = names.find((n) => hcap.key.Code[n] !== undefined);
      if (!name) {
        console.log('[KeyHandlingLG] Medientaste unbekannt: ' + names.join('/'));
        return;
      }
      try {
        hcap.key.addKeyItem({
          "keycode": 0x00000000,
          "virtualKeycode": hcap.key.Code[name],
          "attribute": 2,
          "onSuccess": function() {
            console.log('[KeyHandlingLG] Medientaste angemeldet: ' + name);
          },
          "onFailure": function(f) {
            console.log('[KeyHandlingLG] Medientaste ' + name + ' fehlgeschlagen: ' + (f && f.errorMessage));
          }
        });
      } catch (error) {
        console.log('[KeyHandlingLG] Medientaste ' + name + ': ' + error);
      }
    });
  }

  static unregisterKeys() {
    for (let i = 0; i < this.getKeys.length; i++) {
      try {
        //LG
        //tizen.tvinputdevice.unregisterKey(this.getKeys[i]);
      } catch (error) {
        console.log('failed to register ' + this.getKeys[i] + ': ' + error);
      }
    }
  }

  static setPowerStateListener() {
    const onChange = (context) => {
      const state = context.data;
      console.log('::===> POWER_STATE', state);
      // Symmetrisch: nur 'Normal' = ON, jeder andere Zustand (Standby etc.) = OFF.
      // Sonst bleibt 'ON' im Storage stehen und der Power-Toggle/Restore wäre verschoben.
      if (state === 'Normal') {
        StorageHandler.save(STORE_KEY.POWER_STATE, STORE_VALUE.POWER_ON);
      } else {
        StorageHandler.save(STORE_KEY.POWER_STATE, STORE_VALUE.POWER_OFF);
      }
    };
    try {
      //Device.apis.b2bpower.setPowerStateChangeListener(onChange);
    } catch (error) {
      console.log('[ERROR]: setPowerStateListener!', error);
    }
  }
  static unsetPowerStateListener() {
    try {
      //Device.apis.b2bpower.unsetPowerStateChangeListener();
    } catch (error) {
      console.log('[ERROR]: ON UNSET POWER STATE CHANGE LISTENER', error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/keyHandler/LG.js